'use client';

import React__default from 'react';
import { NoResultWrapper, NoResultIcon, TitleWrapper, Description, ButtonSection } from './EmptyResult.css.js';

var EmptyResult = function (props) {
    var icon = props.icon, title = props.title, description = props.description, style = props.style, _a = props.buttonTitle, buttonTitle = _a === void 0 ? '' : _a, onClick = props.onClick;
    return (React__default.createElement(NoResultWrapper, { style: style },
        React__default.createElement(NoResultIcon, null, icon),
        React__default.createElement(TitleWrapper, null, title),
        description ? React__default.createElement(Description, null, description) : null,
        React__default.createElement(ButtonSection, { onClick: function () {
                onClick && onClick();
            } }, buttonTitle)));
};

export { EmptyResult as default };
//# sourceMappingURL=index.js.map
